import executor from "./api";

const api = executor.getPrefixedMethods("/notes");

export const userNotesService = {
  // Get all notes
  getAllNotes: () => {
    return api.get("");
  },

  // Create a new note
  createNote: (noteData) => {
    return api.post("", noteData);
  },

  // Get a specific note by ID
  getNote: (noteId) => {
    return api.get(`${noteId}/`);
  },

  // Update a note
  updateNote: (noteId, noteData) => {
    return api.put(`${noteId}/`, noteData);
  },

  // Acknowledge a note as the current user
  acknowledgeNote: (noteId) => {
    return api.post(`${noteId}/acknowledge/`);
  },

  // Remove the current user's acknowledgement
  unacknowledgeNote: (noteId) => {
    return api.post(`${noteId}/unacknowledge/`);
  },
};
